import setupDeprecationWorkflow from "ember-cli-deprecation-workflow";
import DeprecationWorkflow from "./deprecation-workflow";

setupDeprecationWorkflow({ workflow: DeprecationWorkflow.emberWorkflowList });
